import {DomainAncestor} from "./DomainAncestor";
import {observable, reaction} from "mobx";
import {LovItem} from "../../metamodel/mdEntity";
import {IDomainObject} from "../../form/formUtils";
import tenantService from "../../tenant/service/tenantService";
import {isTenantNumber} from "../utils/utils";
import mdEntityService from "../../metamodel/mdEntityService";
import {TENANT_ENTITY, TENANT_GROUP_ENTITY} from "../../tenant/constants";
import {ParamTableFormDefinition} from "../../tenant/paramkey/paramTableForm";


export interface EditTenantDto<D extends IDomainObject> {
  dataObject: D;
  tenantGroup?: LovItem;
  tenant?: LovItem;
}

/**
 * For entities that using the only tenantId but tenant edit is wanted from GUI
 */
export abstract class EditableTenantAncestor extends DomainAncestor {

  @observable tenantGroup: LovItem;
  @observable tenant: LovItem;

  constructor(json: IDomainObject) {
    super(json);

  }

  public resolveTenantOrTenantGroup(formName?: string) {
    if (this.tenantId || this.tenantId === 0) {
      tenantService.getTenantLovItem(this.tenantId)
        .then(res => {
          if (res) {
            if (isTenantNumber(res.value))
              this.tenant = res;
            else
              this.tenantGroup = res;

            if (formName) {
              let form = this.getForm(formName);

              form.getField("tenant").props.value = this.tenant;
              form.getField("tenantGroup").props.value = this.tenantGroup;
            }
          }
        })
    }
  }

  public loadTenantOptions(formName: string) {
    mdEntityService.fetchMissingEntityLovs([TENANT_ENTITY, TENANT_GROUP_ENTITY])
      .then(res => this.parseTenantOptionsToProvidedForm(formName, res));
  }

  private parseTenantOptionsToProvidedForm(formName: string, tenantOptions: {[key: string]: LovItem[]}) {
    let form = this.getForm(formName);

    form.getField("tenant").props.options = tenantOptions[TENANT_ENTITY];
    form.getField("tenantGroup").props.options = tenantOptions[TENANT_GROUP_ENTITY];
  }

  public createEditTenantDto(): EditTenantDto<this> {
    return {
      dataObject: this,
      tenantGroup: this.tenantGroup,
      tenant: this.tenant
    };
  }
}



// WEBPACK FOOTER //
// ./src/core/common/domain/EditableTenantAncestor.ts